import React from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { formatFileSize } from '@vy/files';

type ImportContractFilePreviewProps = {
  files: File[];
  onDelete: (file: File) => void;
};

export const ImportContractFilePreview: React.FC<ImportContractFilePreviewProps> = ({ files, onDelete }) => (
  <Stack spacing={1}>
    {files.map((file) => (
      <FileCard key={`${file.name}-${file.size}-${file.lastModified}`} file={file} onDelete={onDelete} />
    ))}
  </Stack>
);

type FileCardProps = {
  file: File;
  onDelete: (file: File) => void;
};

const FileCard: React.FC<FileCardProps> = ({ file, onDelete }) => {
  const fileSizeFormatted = formatFileSize(file.size);

  const handleDelete = () => {
    onDelete(file);
  };

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
        padding: 2,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        backgroundColor: '#F9FAFB'
      }}>
      <Stack direction="row" spacing={1.5} sx={{
        alignItems: "center"
      }}>
        <Stack>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              color: "text.primary"
            }}>
            {file.name}
          </Typography>

          <Typography variant="caption" sx={{
            color: "text.secondary"
          }}>
            {fileSizeFormatted}
          </Typography>
        </Stack>
      </Stack>
      <IconButton onClick={handleDelete} size="small">
        <VyIcon icon="DeleteThin" color="#9E9E9E" />
      </IconButton>
    </Stack>
  );
};
